import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { PaymentFlowItemWithProcessors, useDeletePaymentFlow } from '@/lib/api/paymentFlows';

interface PaymentFlowDeleteDialogProps {
  flow: PaymentFlowItemWithProcessors | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onClose: () => void;
}

export const PaymentFlowDeleteDialog = ({
  flow,
  open,
  onOpenChange,
  onClose,
}: PaymentFlowDeleteDialogProps) => {
  const { t } = useTranslation(['paymentFlows', 'common']);
  const deletePaymentFlow = useDeletePaymentFlow();

  const handleDelete = async () => {
    if (!flow) return;

    try {
      await deletePaymentFlow.mutateAsync({ flowId: flow.id });
      onOpenChange(false);
      onClose();
    } catch (error) {
      // Error is handled by the mutation hook (toast)
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('paymentFlows:delete.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('paymentFlows:delete.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose} disabled={deletePaymentFlow.isPending}>
            {t('common:cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={deletePaymentFlow.isPending}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {deletePaymentFlow.isPending && (
              <Loader2 className="mr-2 size-4 animate-spin" />
            )}
            {t('common:delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};


